// extracted by mini-css-extract-plugin
export var card = "_6e-0";
export var failedIcon = "_6e-4";
export var failedIconBadge = "_6e-3";
export var icon = "_6e-1";
export var successIcon = "_6e-2";